import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, MapPin } from 'lucide-react';
const nombres = ['María', 'Laura', 'Ana', 'Sofía', 'Carolina', 'Gabriela', 'Valeria', 'Natalia', 'Daniela', 'Florencia', 'Lucía', 'Romina', 'Silvina', 'Claudia', 'Andrea', 'Paula', 'Mónica', 'Alejandra', 'Marcela', 'Verónica', 'Cecilia', 'Mariana'];
const ciudades = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca', 'Paraná', 'San Salvador de Jujuy', 'Corrientes', 'San Luis', 'La Rioja', 'Catamarca'];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    nombre: '',
    ciudad: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomNombre = nombres[Math.floor(Math.random() * nombres.length)];
      const randomCiudad = ciudades[Math.floor(Math.random() * ciudades.length)];
      setCurrentPurchase({
        nombre: randomNombre,
        ciudad: randomCiudad
      });
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    };
    // Primera aparición después de 5 segundos
    const initialTimeout = setTimeout(showPopup, 5000);
    // Apariciones subsiguientes cada 8-15 segundos
    const interval = setInterval(() => {
      const randomDelay = 8000 + Math.random() * 7000; // Entre 8 y 15 segundos
      setTimeout(showPopup, randomDelay);
    }, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-60">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: -20
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-61">
          <div className="bg-white rounded-2xl shadow-2xl border border-green-200 p-4 flex items-start gap-3" data-id="element-62">
            <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-63">
              <ShoppingBag className="w-5 h-5 text-green-600" data-id="element-64" />
            </div>
            <div className="flex-1" data-id="element-65">
              <p className="font-bold text-slate-900 text-sm mb-1" data-id="element-66">
                {currentPurchase.nombre} acaba de comprar
              </p>
              <p className="text-xs text-slate-600 flex items-center gap-1" data-id="element-67">
                <MapPin className="w-3 h-3" data-id="element-68" />
                {currentPurchase.ciudad}
              </p>
              <p className="text-xs text-green-600 font-medium mt-1" data-id="element-69">
                Hace unos momentos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}